import React from 'react'
import { string } from 'prop-types'
import SocialShare from 'scripts/helpers/SocialShare'
import locale from 'shared/i18n/react'

class SocialMediaShare extends React.Component {
  static propTypes = {
    url: string.isRequired,
    image: string.isRequired,
    description: string.isRequired
  }

  render() {
    const {url, image, description} = this.props
    return (
      <div className="social-share-container section">
        <div className="social-share-title">{locale.general.shareit}</div>
        <div className="row">
          <div className="col med-3 small-12"><SocialShare type="facebook" buttonText="Facebook" url={url} /></div>
          <div className="col med-3 small-12"><SocialShare type="twitter" buttonText="Twitter" url={url} description={description} /></div>
          <div className="col med-3 small-12"><SocialShare type="pinterest" buttonText="Pinterest" url={url} image={image} description={description} /></div>
          <div className="col med-3 small-12"><SocialShare type="tumblr" buttonText="Tumblr" url={url} description={description} /></div>
        </div>
      </div>
    )
  }
}

export default SocialMediaShare



// WEBPACK FOOTER //
// ./assets/js/components/article/SocialMediaShare.jsx